// extracted by mini-css-extract-plugin
export default {"root":"NotificationBlock_root__aeZyJ","icon":"NotificationBlock_icon__PrtKB"};